module.exports = __webpack_public_path__ + "img/birthday-cake-img.2a9f5248.png";